var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "treeview", attrs: { id: "main-treeview" } },
    [
      _c("v-treeview", {
        attrs: {
          open: _vm.opened_layers,
          items: _vm.items,
          "item-key": [
            "atlas",
            "forecast_observation",
            "monitor",
            "geomap"
          ].includes(_vm.current_tab)
            ? "id"
            : "name",
          "open-on-click": ""
        },
        scopedSlots: _vm._u(
          [
            {
              key: "prepend",
              fn: function(ref) {
                var item = ref.item
                return [
                  item.node && item.layer1 && item.icon
                    ? _c("v-icon", { attrs: { color: "white" } }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(item.icon) +
                            "\n            "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.in_special_list(item.id) && !item.node
                    ? _c("v-checkbox", {
                        staticClass: "checkbox-position",
                        class: {
                          radio_style: item.type === "optional_radio"
                        },
                        attrs: { disabled: _vm.tree_view_disabled },
                        on: {
                          change: function($event) {
                            return _vm.control_special_func(item)
                          }
                        },
                        model: {
                          value: _vm.selectors[item.id].checked,
                          callback: function($$v) {
                            _vm.$set(_vm.selectors[item.id], "checked", $$v)
                          },
                          expression: "selectors[item.id].checked"
                        }
                      })
                    : item.type == "optional_radio" && !item.node
                      ? _c("v-checkbox", {
                          staticClass: "checkbox-position radio_style",
                          attrs: { disabled: _vm.tree_view_disabled },
                          on: {
                            change: function($event) {
                              return _vm.check_optional_radio(item)
                            }
                          },
                          model: {
                            value: _vm.selectors[item.id].checked,
                            callback: function($$v) {
                              _vm.$set(_vm.selectors[item.id], "checked", $$v)
                            },
                            expression: "selectors[item.id].checked"
                          }
                        })
                      : item.type == "cross_type_single_radio" && !item.node
                        ? _c("v-checkbox", {
                            staticClass: "checkbox-position radio_style",
                            attrs: { disabled: _vm.tree_view_disabled },
                            on: {
                              change: function($event) {
                                return _vm.check_all_single_radio(item)
                              }
                            },
                            model: {
                              value: _vm.selectors[item.id].checked,
                              callback: function($$v) {
                                _vm.$set(_vm.selectors[item.id], "checked", $$v)
                              },
                              expression: "selectors[item.id].checked"
                            }
                          })
                        : item.type == "checkbox" && !item.node
                          ? _c("v-checkbox", {
                              staticClass: "checkbox-position",
                              attrs: { disabled: _vm.tree_view_disabled },
                              on: {
                                change: function($event) {
                                  return _vm.check_other_radio(
                                    _vm.selectors[item.id].checked,
                                    item
                                  )
                                }
                              },
                              model: {
                                value: _vm.selectors[item.id].checked,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.selectors[item.id],
                                    "checked",
                                    $$v
                                  )
                                },
                                expression: "selectors[item.id].checked"
                              }
                            })
                          : item.type == "check_all" &&
                            _vm.enable_all_select_in_treeview_children_radios
                            ? _c("v-checkbox", {
                                staticClass: "checkbox-position",
                                on: {
                                  change: function($event) {
                                    return _vm.change_all_checkbox_status(
                                      _vm.selectors[item.id].checked,
                                      item
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.selectors[item.id].checked,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.selectors[item.id],
                                      "checked",
                                      $$v
                                    )
                                  },
                                  expression: "selectors[item.id].checked"
                                }
                              })
                            : item.type == "slider"
                              ? _c("v-checkbox", {
                                  staticClass: "checkbox-position",
                                  class: {
                                    radio_style:
                                      item.sliders_checkbox_style === "radio"
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.control_slide_check_selector(
                                        item
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.selectors[item.id].checked,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.selectors[item.id],
                                        "checked",
                                        $$v
                                      )
                                    },
                                    expression: "selectors[item.id].checked"
                                  }
                                })
                              : _vm._e()
                ]
              }
            },
            {
              key: "append",
              fn: function(ref) {
                var item = ref.item
                return [
                  item.node && item.radio_name
                    ? [
                        _vm.selected_product_count_record[
                          item.radio_name.replace("root", "")
                        ] > 0
                          ? _c(
                              "div",
                              { staticClass: "selected-product-count" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "selected-product-count__text"
                                  },
                                  [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(
                                          _vm.selected_product_count_record[
                                            item.radio_name.replace("root", "")
                                          ]
                                        ) +
                                        "\n                    "
                                    )
                                  ]
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  item.information && item.information.length > 0
                    ? _c(
                        "div",
                        [
                          _c("InformationTooltip", {
                            attrs: { information: item.information }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ]
              }
            },
            {
              key: "label",
              fn: function(ref) {
                var item = ref.item
                return [
                  item.type == "link"
                    ? _c(
                        "a",
                        { attrs: { href: item.href, target: "_blank" } },
                        [_vm._v(_vm._s(item.name))]
                      )
                    : [
                        _vm._v(
                          "\n                " +
                            _vm._s(item.name) +
                            "\n            "
                        )
                      ],
                  _vm._v(" "),
                  _vm.link_icon_list.includes(item.id)
                    ? [_c("v-icon", [_vm._v("mdi-launch")])]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.enable_custom_label
                    ? [_vm._t("content", null, { item: item })]
                    : _vm._e(),
                  _vm._v(" "),
                  item.type == "slider"
                    ? [
                        item.sliders
                          ? _c("MenuSlider", {
                              ref: item.id,
                              staticClass: "slider__wrapper",
                              attrs: {
                                item: item,
                                tick_id: _vm.selectors[item.id].tick,
                                slider_ticks_mapping: _vm.slider_ticks_mapping
                              },
                              on: {
                                "change-slider-tick":
                                  _vm.control_slide_check_selector
                              }
                            })
                          : _vm._e()
                      ]
                    : _vm._e()
                ]
              }
            }
          ],
          null,
          true
        ),
        model: {
          value: _vm.tree,
          callback: function($$v) {
            _vm.tree = $$v
          },
          expression: "tree"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }